import PropTypes from 'prop-types';
import { useState } from 'react';

import { Box } from '@mui/material';

import StyledTimePicker from '../../TimePicker';

const TimePicker = ({
  placeholder,
  time: {
    value: formValue,
    name,
    onChange,
    disabled,
    getDisabledHours,
    getDisabledMinutes,
  },
  index,
  hasError,
}) => {
  const [value, setValue] = useState(formValue);
  const onClose = () => onChange(value, name, index);

  return (
    <Box width="9rem" display="flex" height="4.2rem" alignItems="center">
      <StyledTimePicker
        onChange={(newValue) => setValue(newValue)}
        onClose={onClose}
        value={value || null}
        disabled={disabled}
        allowEmpty={false}
        showSecond={false}
        disabledHours={() => getDisabledHours && getDisabledHours()}
        disabledMinutes={(selectedHour) =>
          getDisabledMinutes && getDisabledMinutes(selectedHour)
        }
        format="hh:mm A"
        showNow={false}
        inputIcon={null}
        minuteStep={15}
        use12Hours
        placeholder={placeholder}
        hasError={hasError}
      />
    </Box>
  );
};
TimePicker.propTypes = {
  placeholder: PropTypes.string.isRequired,
  time: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    getDisabledHours: PropTypes.func,
    getDisabledMinutes: PropTypes.func,
  }).isRequired,
  index: PropTypes.number.isRequired,
  hasError: PropTypes.bool.isRequired,
};

export default TimePicker;
